import { InstallmentFrequency } from './installment-frequency';

export class Recurring {
	firstPaymentDate: string;
	frequency: InstallmentFrequency;
	lastPaymentDate: string;
	numberOfRetriesForCardDeclines: number;
	paymentAmount: string;
}
